import { WagepointTheme } from 'styles/wagepointTheme';

const { palette } = WagepointTheme();

export const cellMinHeight = 56;
export const disabledThemeColor = palette.background.default; // to control the entire theme color for the diabled table view
